/** Build one multilingual FAQ entry. */
export function faqItem(id, sectionKey, sectionEn, qEn, aEn, de, fr, nl) {
  return {
    id,
    sectionKey,
    section: { en: sectionEn, de: de.section, fr: fr.section, nl: nl?.section || sectionEn },
    q: { en: qEn, de: de.q, fr: fr.q, nl: nl?.q || qEn },
    a: { en: aEn, de: de.a, fr: fr.a, nl: nl?.a || aEn },
  };
}

/** Resolve localized field with English fallback. */
export function faqText(field, lang) {
  if (!field || typeof field !== 'object') return field || '';
  return field[lang] || field.en || '';
}
